import React, { Component, Fragment } from 'react';
import axios from 'axios';
import { Loader, Segment, Header, Form, Message, Table, Grid, Button, Icon, Popup } from 'semantic-ui-react';
import ReactExport from 'react-data-export';
import ReportExcelFile from '../StudentService/StudentsReports/ReportExcelFile';
import PaginationFront from '../util/PaginationFront';
import { sanitizeExcelDataSet } from '../util/sanitizeExcel';
import { fetchAcademicYears, fetchCountries } from '../Lookups/util';
import {
    additionalFilterSectionStyle,
    filterFieldGridStyle
} from '../StudentService/StudentsReports/reportUiHelpers';
import MobilityDetails from '../StudentService/StudentOverview/MobilityDetails';

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

const normalize = (value) => (value || '').toString().toLowerCase();

const filterMobilities = (state) => {
    const searchText = normalize(state.searchText);
    let filteredMobilities = state.mobilities;

    if (state.selectedAcademicYearId) {
        filteredMobilities = filteredMobilities.filter(mobility =>
            mobility.academicYearId === state.selectedAcademicYearId
        );
    }

    if (state.selectedCountryId) {
        filteredMobilities = filteredMobilities.filter(mobility =>
            mobility.countryId === state.selectedCountryId
        );
    }

    if (searchText) {
        filteredMobilities = filteredMobilities.filter(mobility =>
            [
                mobility.firstName,
                mobility.lastName,
                mobility.indexNumber,
                mobility.studentFacultyName,
                mobility.universityName,
                mobility.facultyName,
                mobility.countryName,
                mobility.academicYearName,
            ].some(value => normalize(value).indexOf(searchText) !== -1)
        );
    }

    return {
        filteredMobilities,
        excelData: [{
            columns: [
                { title: 'Ime', width: { wpx: 120 } },
                { title: 'Prezime', width: { wpx: 120 } },
                { title: 'Broj indeksa', width: { wpx: 110 } },
                { title: 'Fakultet studenta', width: { wpx: 300 } },
                { title: 'Univerzitet', width: { wpx: 300 } },
                { title: 'Fakultet', width: { wpx: 300 } },
                { title: 'Drzava', width: { wpx: 180 } },
                { title: 'Akademska godina', width: { wpx: 140 } },
                { title: 'Semestar mobilnosti', width: { wpx: 160 } },
                { title: 'Semestar studija', width: { wpx: 160 } },
            ],
            data: filteredMobilities.map(mobility => ([
                { value: mobility.firstName || '' },
                { value: mobility.lastName || '' },
                { value: mobility.indexNumber || '' },
                { value: mobility.studentFacultyName || '' },
                { value: mobility.universityName || '' },
                { value: mobility.facultyName || '' },
                { value: mobility.countryName || '' },
                { value: mobility.academicYearName || '' },
                { value: mobility.semesterName || '' },
                { value: mobility.studyProgramSemesterName || '' },
            ]))
        }]
    };
};

class OutgoingMobilityStudentList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobilities: [],
            filteredMobilities: [],
            academicYears: [],
            countries: [],
            selectedAcademicYearId: null,
            selectedCountryId: null,
            searchText: '',
            activePage: 1,
            postsPerPage: 10,
            excelData: [],
            loading: true,
            detailsLoading: false,
            selectedMobility: null,
        };

        this.fetchInitialData = this.fetchInitialData.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.openMobilityDetails = this.openMobilityDetails.bind(this);
        this.closeMobilityDetails = this.closeMobilityDetails.bind(this);
    }

    componentDidMount() {
        this.fetchInitialData();
    }

    fetchInitialData() {
        this.setState({ loading: true });

        const emptyResponse = { data: [] };

        axios.all([
            axios.get('/student-study-program-mobility/outgoing/').catch(() => emptyResponse),
            fetchAcademicYears().catch(() => emptyResponse),
            fetchCountries().catch(() => emptyResponse),
        ])
            .then(axios.spread((mobilitiesResponse, academicYearsResponse, countriesResponse) => {
                const mobilities = mobilitiesResponse.data || [];
                const academicYears = (academicYearsResponse.data || []).map(year => ({
                    key: year.id,
                    text: year.name,
                    value: year.id,
                    startYear: year.startYear,
                })).sort((a, b) => (b.startYear || 0) - (a.startYear || 0));
                const countries = (countriesResponse.data || []).map(country => ({
                    key: country.id,
                    text: country.name,
                    value: country.id,
                })).sort((a, b) => a.text.localeCompare(b.text));
                const currentAcademicYearId = academicYears.length > 0 ? academicYears[0].value : null;

                this.setState({
                    mobilities,
                    academicYears,
                    countries,
                    selectedAcademicYearId: currentAcademicYearId || null,
                    activePage: 1,
                    loading: false,
                }, this.applyFilters);
            }))
            .catch(() => {
                this.setState({ loading: false });
            });
    }

    applyFilters() {
        const filteredData = filterMobilities(this.state);
        this.setState({
            filteredMobilities: filteredData.filteredMobilities,
            excelData: filteredData.excelData,
            activePage: 1,
        });
    }

    handleFilterChange(name, value) {
        const applyFiltersOnChange = this.props.applyFiltersOnChange !== false;
        this.setState({ [name]: value, activePage: 1 }, () => {
            if (applyFiltersOnChange) {
                this.applyFilters();
            } else if (this.props.onFiltersChange) {
                this.props.onFiltersChange();
            }
        });
    }

    handlePaginationChange(e, { activePage }) {
        this.setState({ activePage });
    }

    openMobilityDetails(mobility) {
        this.setState({ detailsLoading: true });
        axios.get(`/student-study-program-mobility/${mobility.mobilityId}/`)
            .then((response) => {
                const selectedMobility = response.data;
                localStorage.setItem('mob', JSON.stringify(selectedMobility));
                this.setState({
                    selectedMobility,
                    detailsLoading: false,
                });
                window.scrollTo(0, 0);
            })
            .catch(() => {
                this.setState({ detailsLoading: false });
            });
    }

    closeMobilityDetails() {
        this.setState({ selectedMobility: null });
    }

    render() {
        const {
            mobilities,
            filteredMobilities,
            academicYears,
            countries,
            selectedAcademicYearId,
            selectedCountryId,
            searchText,
            activePage,
            postsPerPage,
            excelData,
            loading,
            detailsLoading,
            selectedMobility,
        } = this.state;
        const indexOfLastPost = activePage * postsPerPage;
        const indexOfFirstPost = indexOfLastPost - postsPerPage;
        const currentMobilities = filteredMobilities.slice(indexOfFirstPost, indexOfLastPost);
        const title = this.props.title || 'Odlazne mobilnosti';
        const ExportFile = this.props.reportPdf ? ReportExcelFile : ExcelFile;
        const header = this.props.header || 'Studenti odlazne mobilnosti';
        const description = this.props.description;
        const compact = this.props.compact;
        const hideStudentFacultyColumn = this.props.hideStudentFacultyColumn;
        const activeRole = localStorage.getItem('activeRole') || '';
        const showMobilityDetailsAction = activeRole.startsWith('Prodekan za me')
            || activeRole.startsWith('Prodekan za nastavu');
        const tableColumnSpan = hideStudentFacultyColumn
            ? (showMobilityDetailsAction ? 8 : 7)
            : (showMobilityDetailsAction ? 10 : 9);
        const filterFields = (
            <Form>
                <Form.Group widths="equal" style={filterFieldGridStyle}>
                    <Form.Select
                        search
                        clearable
                        fluid
                        label="Akademska godina"
                        placeholder="Sve akademske godine"
                        options={academicYears}
                        value={selectedAcademicYearId}
                        onChange={(e, { value }) => this.handleFilterChange('selectedAcademicYearId', value)}
                    />
                    <Form.Select
                        search
                        clearable
                        fluid
                        label="Država"
                        placeholder="Sve države"
                        options={countries}
                        value={selectedCountryId}
                        onChange={(e, { value }) => this.handleFilterChange('selectedCountryId', value)}
                    />
                </Form.Group>
            </Form>
        );
        const filters = this.props.filtersInBox ? (
            <Segment style={additionalFilterSectionStyle}>
                <Header as="h4" color="blue">Dodatni filteri</Header>
                {filterFields}
            </Segment>
        ) : filterFields;
        const actions = this.props.renderActions ? this.props.renderActions() : null;
        if (selectedMobility) {
            if (this.props.plainDetails) {
                return (
                    <div>
                        <Header as="h3">Detalji mobilnosti</Header>
                        <MobilityDetails
                            limitation
                            mob={selectedMobility}
                            onBack={this.closeMobilityDetails}
                            hideBackButton={this.props.hideDetailsBackButton}
                        />
                    </div>
                );
            }

            return (
                <div>
                    <h2>{title}</h2>
                    <Segment.Group raised>
                        <Segment>
                            <Header as="h3" style={{ margin: 0 }}>
                                Detalji mobilnosti
                            </Header>
                        </Segment>
                        <Segment>
                            <MobilityDetails
                                limitation
                                mob={selectedMobility}
                                onBack={this.closeMobilityDetails}
                                hideBackButton={this.props.hideDetailsBackButton}
                            />
                        </Segment>
                    </Segment.Group>
                </div>
            );
        }

        const table = loading ? (
            <Loader active inline="centered"/>
        ) : (
            <Fragment>
                {!compact && description && (
                    <Message>
                        {description}
                    </Message>
                )}
                <Table celled selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell colSpan={tableColumnSpan}>
                                <Grid stackable verticalAlign="middle">
                                    <Grid.Column width={14}>
                                        <Form>
                                            <Form.Input
                                                icon="search"
                                                iconPosition="left"
                                                placeholder="Pretraga"
                                                value={searchText}
                                                onChange={(e, { value }) =>
                                                    this.setState({ searchText: value, activePage: 1 }, this.applyFilters)
                                                }
                                            />
                                        </Form>
                                    </Grid.Column>
                                    <Grid.Column width={2} textAlign="right">
                                        <ExportFile filename="Studenti na odlaznoj mobilnosti" element={<Popup
                                            trigger={<Button animated="vertical" color="green" basic
                                                             floated="right" fluid
                                                             style={{ textAlign: 'center' }}>
                                                <Button.Content hidden>
                                                    <Icon name="download"/>
                                                </Button.Content>
                                                <Button.Content visible>
                                                    Excel
                                                </Button.Content>
                                            </Button>}
                                            content="Preuzmi Excel"
                                            hideOnScroll
                                            position="top center"
                                        />}>
                                            <ExcelSheet dataSet={sanitizeExcelDataSet(excelData)} name="Studenti"/>
                                        </ExportFile>
                                    </Grid.Column>
                                </Grid>
                            </Table.HeaderCell>
                        </Table.Row>
                        <Table.Row>
                            <Table.HeaderCell colSpan={2}>
                                Ime i prezime
                                <div style={{ fontSize: '0.85em', color: '#999' }}>
                                    Broj indeksa
                                </div>
                            </Table.HeaderCell>
                            {!hideStudentFacultyColumn && (
                                <Table.HeaderCell colSpan={2}>Fakultet studenta</Table.HeaderCell>
                            )}
                            <Table.HeaderCell colSpan={2}>
                                Institucija
                                <div style={{ fontSize: '0.85em', color: '#999' }}>
                                    Univerzitet / fakultet
                                </div>
                            </Table.HeaderCell>
                            <Table.HeaderCell>Država</Table.HeaderCell>
                            <Table.HeaderCell>
                                Akademska godina
                                <div style={{ fontSize: '0.85em', color: '#999' }}>
                                    Semestar
                                </div>
                            </Table.HeaderCell>
                            <Table.HeaderCell>Semestar studija</Table.HeaderCell>
                            {showMobilityDetailsAction && <Table.HeaderCell width={1} />}
                        </Table.Row>
                    </Table.Header>
                    {filteredMobilities.length > 0 ? (
                        <Table.Body>
                            {currentMobilities.map((mobility, index) => (
                                <Table.Row key={mobility.mobilityId || index}>
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        <div>{indexOfFirstPost + index + 1}. {mobility.firstName} {mobility.lastName}</div>
                                        <div style={{ fontSize: '0.85em', color: '#999' }}>
                                            {mobility.indexNumber || '-'}
                                        </div>
                                    </Table.Cell>
                                    {!hideStudentFacultyColumn && (
                                        <Table.Cell verticalAlign="middle" colSpan={2}>
                                            {mobility.studentFacultyName || '-'}
                                        </Table.Cell>
                                    )}
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        <div>{mobility.universityName || '-'}</div>
                                        <div style={{ fontSize: '0.85em', color: '#999' }}>
                                            {mobility.facultyName || '-'}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {mobility.countryName || '-'}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        <div>{mobility.academicYearName || '-'}</div>
                                        <div style={{ fontSize: '0.85em', color: '#999' }}>
                                            {mobility.semesterName || '-'}
                                        </div>
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {mobility.studyProgramSemesterName || '-'}
                                    </Table.Cell>
                                    {showMobilityDetailsAction && (
                                        <Table.Cell textAlign="center" verticalAlign="middle">
                                            <Popup
                                                content="Detalji mobilnosti"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic
                                                        circular
                                                        icon="align justify"
                                                        size="small"
                                                        color="blue"
                                                        loading={detailsLoading}
                                                        disabled={detailsLoading}
                                                        onClick={() => this.openMobilityDetails(mobility)}
                                                    />
                                                }
                                            />
                                        </Table.Cell>
                                    )}
                                </Table.Row>
                            ))}
                        </Table.Body>
                    ) : (
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell colSpan={tableColumnSpan} textAlign="left">
                                    Nema podataka za prikaz.
                                </Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    )}
                </Table>
                {filteredMobilities.length > postsPerPage &&
                    <PaginationFront
                        postsPerPage={postsPerPage}
                        totalPosts={filteredMobilities.length}
                        paginate={this.handlePaginationChange}
                        activePage={activePage}
                    />}
                {/*<div style={{ color: '#777', marginTop: '8px' }}>*/}
                {/*    Prikazano {filteredMobilities.length} od {mobilities.length} zapisa.*/}
                {/*</div>*/}
            </Fragment>
        );

        if (compact) {
            return (
                <div>
                    {filters}
                    {actions}
                    {this.props.showResults !== false &&
                        (loading || filteredMobilities.length > 0 ? table : <p>Nema podataka.</p>)}
                </div>
            );
        }

        return (
            <div>
                <h2>{title}</h2>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3" style={{ margin: 0 }}>
                            {header}
                        </Header>
                    </Segment>
                    <Segment>
                        {filters}
                        {actions}
                    </Segment>
                    <Segment>
                        {table}
                    </Segment>
                </Segment.Group>
            </div>
        );
    }
}

export default OutgoingMobilityStudentList;



// WEBPACK FOOTER //
// ./src/views/OutgoingMobilityStudents/OutgoingMobilityStudentList.js